import io from 'socket.io-client'
import DacyServer from "./dacyserver";
const socket = io(DacyServer.getInstance().getURL() + '/socket.io/clients', {
} );
export default socket
